import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getUserInfo } from "api";

export default function useFindUser() {
	const location = useLocation();
	const [user, setUser] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	const findUser = async () => {
		try {
			const res = await getUserInfo();
			const newData = { ...res.data };
			setUser(newData);
			sessionStorage.setItem("DATA_SERVICES_USER", JSON.stringify(newData));
		} catch (err) {
			return false;
		} finally {
			setIsLoading(false);
		}
	};
	useEffect(() => {
		const isMaintenance = location.pathname === "/maintenance";
		!isMaintenance && findUser();
	}, []);

	return {
		user,
		setUser,
		findUser,
		isLoading,
	};
}
